import { Orders } from '@src/containers/Blotters/Orders';
import { MixpanelEventSource, MixpanelSourceProvider } from '@talos/kyoko';
import type { OrdersBlotterPanelConfig } from '../../../../../types/LayoutConfig';
import type { LayoutPanelProps } from '../../../types';
import { BlotterPanel } from './BlotterPanel';

export function OrdersPanel({ params, api }: LayoutPanelProps<OrdersBlotterPanelConfig>) {
  return (
    <MixpanelSourceProvider value={MixpanelEventSource.OrdersBlotter}>
      <BlotterPanel
        panelApi={api}
        panelTabs={params.tabs}
        panelBlottersState={params.blotterTablesState}
        data-testid="orders-blotter-panel"
      >
        <Orders />
      </BlotterPanel>
    </MixpanelSourceProvider>
  );
}

export default OrdersPanel;
